
export default {
  inheritAttrs: false,
  props: {
    calories: { type: String, default: null },
    carbohydrateContent: { type: String, default: null },
    cholesterolContent: { type: String, default: null },
    fatContent: { type: String, default: null },
    fiberContent: { type: String, default: null },
    proteinContent: { type: String, default: null },
    saturatedFatContent: { type: String, default: null },
    servingSize: { type: String, default: null },
    sodiumContent: { type: String, default: null },
    sugarContent: { type: String, default: null },
    unsaturatedFatContent: { type: String, default: null },
  },
};
